// Every feature module in one place: i18n merges their strings, the router loads their pages.
import * as accounting from "@/modules/accounting";
import * as appointments from "@/modules/appointments";
import * as auth from "@/modules/auth";
import * as crm from "@/modules/crm";
import * as dashboard from "@/modules/dashboard";
import * as directory from "@/modules/directory";
import * as helpdesk from "@/modules/helpdesk";
import * as hr from "@/modules/hr";
import * as inventory from "@/modules/inventory";
import * as invoicing from "@/modules/invoicing";
import * as payroll from "@/modules/payroll";
import * as pos from "@/modules/pos";
import * as projects from "@/modules/projects";
import * as realestate from "@/modules/realestate";
import * as requests from "@/modules/requests";
import * as settings from "@/modules/settings";

export const modules = { accounting, appointments, auth, crm, dashboard, directory, helpdesk, hr, inventory, invoicing, payroll, pos, projects, realestate, requests, settings };
